// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{
    isOpen: boolean;
}>;

export const DispatchSetIsOpen: HandlerType = ({ dispatch, parameter: { isOpen } }) => {
    dispatch({
        type: "Greif/Components/CookiePrivacyPolicy/SetIsOpen",
        isOpen,
    });
};

export const chain = [DispatchSetIsOpen];

const setCookieDrawerIsOpen = createHandlerChainRunner(chain, "SetCookieDrawerIsOpen");
export default setCookieDrawerIsOpen;
